import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSSelectCtr } from 'components';
import { formHasField } from 'features/arretTravail/models/scenarii';
import { employmentStatusOptions } from 'features/arretTravail/models/StopInformation';
import React from 'react';
import styles from '../../../../css/ArretTravail.module.scss';

type SituationAtStopDateSectionProps = {
    store: any;
};

const SituationAtStopDate: React.FC<SituationAtStopDateSectionProps> = ({ store }) => {
    const hasSituationAtStopDate = formHasField(['workStoppage.infos.situationAtStopDateCod'], 'formAtFields', store);

    if (!hasSituationAtStopDate) {
        delete store?.workStoppage?.infos?.situationAtStopDateCod;
        return null;
    }

    return (
        <>
            <Box className={classNames(styles.title, 'mb-4')}>Situation à la date de l'arrêt :</Box>
            <SGSForm.Row>
                <SGSForm.Col md={6}>
                    <SGSSelectCtr
                        name="workStoppage.infos.situationAtStopDateCod"
                        options={employmentStatusOptions}
                        variant="outlined"
                        label="workStop.fields.workStoppage.infos.situationAtStopDate"
                    />
                </SGSForm.Col>
            </SGSForm.Row>
        </>
    );
};

export default SituationAtStopDate;
